import DoctorController from './DoctorController'
export default DoctorController
export { default as PrescriptionExpired } from './PrescriptionExpired'
export { default as NewDoctorRequired } from './NewDoctorRequired'